export const PERFORMANCE_PERMISSIONS = {
  GOALS_CREATE: "performance.goals.create",
  GOALS_READ: "performance.goals.read",
  GOALS_UPDATE: "performance.goals.update",
  GOALS_DELETE: "performance.goals.delete",
  FEEDBACK_CREATE: "performance.feedback.create",
  FEEDBACK_READ: "performance.feedback.read",
  COMPETENCIES_CREATE: "performance.competencies.create",
  COMPETENCIES_READ: "performance.competencies.read",
  COMPETENCIES_UPDATE: "performance.competencies.update",
  COMPETENCIES_DELETE: "performance.competencies.delete",
  REVIEWS_CREATE: "performance.reviews.create",
  REVIEWS_READ: "performance.reviews.read",
  REVIEWS_UPDATE: "performance.reviews.update",
  REVIEWS_FINALIZE: "performance.reviews.finalize",
  REVIEW_APPROVE: "performance.review.approve",
  CALIBRATIONS_MANAGE: "performance.calibrations.manage",
  CALIBRATIONS_READ: "performance.calibrations.read",
  APPRAISAL_360_MANAGE: "performance.360.manage",
  APPRAISAL_360_READ: "performance.360.read",
  ANALYTICS_READ: "performance.analytics.read",
};

const ROLES = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  HR_HEAD: "HRHead",
  HR_EXECUTIVE: "HRExecutive",
  MANAGER: "Manager",
  TEAM_LEAD: "TeamLead",
  EMPLOYEE: "Employee",
  FINANCE: "Finance",
  AUDITOR: "Auditor",
};

const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: Object.values(PERFORMANCE_PERMISSIONS),
  [ROLES.ADMIN]: Object.values(PERFORMANCE_PERMISSIONS),
  [ROLES.HR_HEAD]: Object.values(PERFORMANCE_PERMISSIONS),
  [ROLES.HR_EXECUTIVE]: [
    PERFORMANCE_PERMISSIONS.GOALS_READ,
    PERFORMANCE_PERMISSIONS.FEEDBACK_CREATE,
    PERFORMANCE_PERMISSIONS.FEEDBACK_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_CREATE,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_UPDATE,
    PERFORMANCE_PERMISSIONS.REVIEWS_CREATE,
    PERFORMANCE_PERMISSIONS.REVIEWS_READ,
    PERFORMANCE_PERMISSIONS.REVIEWS_UPDATE,
    PERFORMANCE_PERMISSIONS.CALIBRATIONS_READ,
    PERFORMANCE_PERMISSIONS.APPRAISAL_360_READ,
    PERFORMANCE_PERMISSIONS.ANALYTICS_READ,
  ],
  [ROLES.MANAGER]: [
    PERFORMANCE_PERMISSIONS.GOALS_CREATE,
    PERFORMANCE_PERMISSIONS.GOALS_READ,
    PERFORMANCE_PERMISSIONS.GOALS_UPDATE,
    PERFORMANCE_PERMISSIONS.FEEDBACK_CREATE,
    PERFORMANCE_PERMISSIONS.FEEDBACK_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_CREATE,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_UPDATE,
    PERFORMANCE_PERMISSIONS.REVIEWS_CREATE,
    PERFORMANCE_PERMISSIONS.REVIEWS_READ,
    PERFORMANCE_PERMISSIONS.REVIEWS_UPDATE,
    PERFORMANCE_PERMISSIONS.CALIBRATIONS_READ,
    PERFORMANCE_PERMISSIONS.APPRAISAL_360_READ,
    PERFORMANCE_PERMISSIONS.ANALYTICS_READ,
  ],
  [ROLES.TEAM_LEAD]: [
    PERFORMANCE_PERMISSIONS.GOALS_READ,
    PERFORMANCE_PERMISSIONS.FEEDBACK_CREATE,
    PERFORMANCE_PERMISSIONS.FEEDBACK_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_READ,
    PERFORMANCE_PERMISSIONS.REVIEWS_READ,
    PERFORMANCE_PERMISSIONS.APPRAISAL_360_READ,
  ],
  [ROLES.EMPLOYEE]: [
    PERFORMANCE_PERMISSIONS.GOALS_READ,
    PERFORMANCE_PERMISSIONS.FEEDBACK_CREATE,
    PERFORMANCE_PERMISSIONS.FEEDBACK_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_READ,
    PERFORMANCE_PERMISSIONS.REVIEWS_READ,
  ],
  [ROLES.FINANCE]: [PERFORMANCE_PERMISSIONS.ANALYTICS_READ],
  [ROLES.AUDITOR]: [
    PERFORMANCE_PERMISSIONS.GOALS_READ,
    PERFORMANCE_PERMISSIONS.FEEDBACK_READ,
    PERFORMANCE_PERMISSIONS.COMPETENCIES_READ,
    PERFORMANCE_PERMISSIONS.REVIEWS_READ,
    PERFORMANCE_PERMISSIONS.CALIBRATIONS_READ,
    PERFORMANCE_PERMISSIONS.APPRAISAL_360_READ,
    PERFORMANCE_PERMISSIONS.ANALYTICS_READ,
  ],
};

export const getRolePerformancePermissions = (role) =>
  ROLE_PERMISSIONS[role] || [];
